import React, { memo } from 'react';
import { useSelectedRole } from '../../../../hooks/useSelectedRole';
import { RoleHeading } from '../RoleHeading';
import { OverviewHeading } from '../OverviewHeading';

interface BaseInfoProps {
    withAvatar?: boolean;
}

export const BaseInfo: React.FC<BaseInfoProps> = memo(({ withAvatar }: BaseInfoProps) => {
    const selectedRole = useSelectedRole();

    if (selectedRole) {
        return <RoleHeading sellerRoleId={selectedRole.id} withAvatar={withAvatar} />;
    }

    return <OverviewHeading />;
});

BaseInfo.displayName = 'BaseInfo';
